import React from "react";
import {
    Field, reduxForm, touch
} from "redux-form";
import FormField from "@/components/forms/form-field";
import WordsLimitedField from "@/components/forms/words-limited-field";
import GoogleMapsAutocompleteField from "@/components/forms/google-maps-autocomplete";

// Local storage + validation setup
const STEP3_FIELDS = ["address_data", "project_background", "is_released", "which_song", "posted_info", "question", "song_url"];

/**                                                                                                                                                                                                   │
 * Validates if a given string is a well-formed URL.                                                                                                                                                  │
 *                                                                                                                                                                                                    │
 * @param {string} url The URL string to validate.                                                                                                                                                    │
 * @returns {boolean} True if the URL is valid, False otherwise.                                                                                                                                      │
 */
function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
}

// Validation logic
const validateStep3 = (values) => {
    const errors = {};
    if (!values.address_data) {
        errors.address_data = 'Address is required';
    } else if (!values.address_data.address || !values.address_data.city || !values.address_data.state || !values.address_data.zip) {
        const missing = [];
        if (!values.address_data.address) missing.push('street address');
        if (!values.address_data.city) missing.push('city');
        if (!values.address_data.state) missing.push('state');
        if (!values.address_data.zip) missing.push('zip code');
        errors.address_data = `Please select a complete address with ${missing.join(', ')}`;
    }
    if (!values.project_background) {
        errors.project_background = 'Background is required';
    }
    if (values.is_released) {
        if (!values.which_song) errors.which_song = 'Song name is required for released song';
        if (!values.posted_info) errors.posted_info = 'Posting info is required';
    }
    if (!values.question) errors.question = 'Your question is required';
    if (!values.song_url) errors.song_url = 'Song upload is required';
    if (values.song_url && !isValidUrl(values.song_url)) {
        errors.song_url = 'Song URL is invalid';
    }
    return errors;
};

// Functional component, manually "touches" all on invalid submitting
const ReviewStep3 = ({
                         handleSubmit, submitting, onSubmit, onPrev, invalid, dispatch,
                     }) => {

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // manually run handleSubmit, which will only call onSubmit if valid
        handleSubmit((values) => {
            onSubmit(values);
        })();
        // If the form is invalid, "touch" all fields so errors appear everywhere
        if (invalid) {
            dispatch(touch("sampleReviewStep3", ...STEP3_FIELDS));
        }
    };


    return (<form onSubmit={handleFormSubmit} className="form-layout" noValidate>
        <Field
            name="address_data"
            component={GoogleMapsAutocompleteField}
            returnFormat="object"
            required
            label="Address"
            placeholder="Start typing your address..."
        />
        <Field
            name="song_url"
            component={FormField}
            type="text"
            label="Submit your song URL (Must be complete with Vocals)"
            disabled={true}
        />
        <Field
            name="which_song"
            component={FormField}
            type="text"
            label="Have you released your song? Where if so?"
        />
        <Field
            name="posted_info"
            component={FormField}
            type="text"
            label="When and where is it posted?"
        />
        <Field
            name="question"
            component={WordsLimitedField}
            required
            maxWords={200}
            label="What is your question? Please provide any details you may have on the sample used."
        />

        <div className="submit-row_txt">
            <button
                type="button"
                className="btn btn-primary"
                onClick={onPrev}
                disabled={submitting}
                style={{marginRight: 12}}
            >
                Previous
            </button>
            <button
                type="submit"
                className="btn-red-primary"
                disabled={submitting}
            >
                Go to Checkout
            </button>
        </div>
    </form>);
};

export default reduxForm({
    form: "sampleReviewStep3",
    validate: validateStep3,
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: false,
    touchOnBlur: true,
    touchOnChange: false,
})(ReviewStep3);
